import { Button, Tooltip } from '@fluentui/react-components';
import { Sparkle20Filled, Sparkle20Regular } from '@fluentui/react-icons';
import { useMyMoments, useSaveMomentSettings } from '../../api/moments';

// The per-person OFF SWITCH (fleet rule 5), in the header beside the theme toggle — the app's other
// per-person setting. Saving sends ONLY the enabled field; the server merges, so the seen record is
// kept. Absent while the facts are unavailable, so it never offers a switch for nothing.

export default function MomentsToggle({ className }: { className?: string }) {
  const { data, isSuccess } = useMyMoments();
  const { mutate: save, isPending } = useSaveMomentSettings();
  if (!isSuccess || !data?.available) return null;

  const label = data.enabled ? 'Turn off celebrations' : 'Turn on celebrations';
  return (
    <Tooltip content={label} relationship="label">
      <Button
        appearance="subtle"
        className={className}
        aria-pressed={data.enabled}
        disabled={isPending}
        icon={data.enabled ? <Sparkle20Filled /> : <Sparkle20Regular />}
        onClick={() => save({ enabled: !data.enabled })}
      />
    </Tooltip>
  );
}
